/*
  _________________________
< Here be a countdown timer >
  -------------------------
         \   ^__^ 
          \  (oo)\_______
             (__)\       )\/\
                 ||----w |
                 ||     ||
*/

function getTimeRemaining(endtime) {
  const total = Date.parse(endtime) - Date.parse(new Date());
  const seconds = Math.floor((total / 1000) % 60);
  const minutes = Math.floor((total / 1000 / 60) % 60);
  const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
  const days = Math.floor(total / (1000 * 60 * 60 * 24));

  return {
    total,
    days,
    hours,
    minutes,
    seconds,
  };
}

function countdownVisibility(today, schedule, deadline) {
  let visibility = true;

  // IS IT A WEEKDAY
  let weekend = false;
  if (today.getDay() === 0 || today.getDay() === 6) {
    weekend = true;
  }

  // GET TODAY SHORT DATE
  let shortToday = today;
  let ye = new Intl.DateTimeFormat('en', {year: 'numeric'}).format(today);
  let mo = new Intl.DateTimeFormat('en', {month: '2-digit'}).format(today);
  let da = new Intl.DateTimeFormat('en', {day: '2-digit'}).format(today);
  shortToday = `${da}/${mo}/${ye}`;

  // SET MIDNIGHT TIMES
  let preMid = new Date(today);
  let postMid = new Date(today);

  preMid.setHours(23, 59, 59, 0);
  postMid.setHours(0, 0, 1, 0);

  // GET ALL TIMES IN MILLISECONDS
  const currentTimeMilliseconds = new Date(today).getTime();
  const preMidMilliseconds = new Date(preMid).getTime();
  const postMidMilliseconds = new Date(postMid).getTime();
  const deadlineMilliseconds = new Date(deadline).getTime();

  // IF TODAY IS IN THE SCHEDULE OF HOLIDAYS, THEN HIDE THE COUNTDOWN
  if (schedule.includes(shortToday)) {
    visibility = false;
  } else {
    if (weekend) {
      visibility = false;
    } else {
      // if the current time is after the deadline(16:00:00) and before premid(11:59:59), then hide the countdown
      if (
        currentTimeMilliseconds > deadlineMilliseconds &&
        currentTimeMilliseconds < preMidMilliseconds
      ) {
        visibility = false;
      }

      // if the current time is after postmid(00:00:01) and before the deadline(16:00:00), then show the countdown
      if (
        currentTimeMilliseconds > postMidMilliseconds &&
        currentTimeMilliseconds < deadlineMilliseconds
      ) {
        visibility = true;
      }
    }
  }

  return visibility;
}

function initializeClock(el, deadline, schedule, today) {
  const visibility = countdownVisibility(today, schedule, deadline);

  // completley hide if its gone past the cut off point
  if (!visibility) {
    el.style.display = 'none';
  }

  const timeinterval = setInterval(() => {
    const t = getTimeRemaining(deadline);
    const output = el.querySelector('span.countdown-js');
    output.innerHTML =
      'Order in ' +
      t.hours +
      ' hours ' +
      t.minutes +
      ' minutes and ' +
      t.seconds +
      ' seconds';
    if (t.total <= 0) {
      clearInterval(timeinterval);
    }
  }, 1000);
}

export default function () {
  const url = window.location.href;

  if (url.includes('/products/')) {
    // WHERE TO PLACE THE COUNTDOWN
    const clock = document.querySelector('[data-countdown="active"]');

   
    
   
    // IF CLOCK SPAN EXISTS, INITIALIZE THE CLOCK
    if (clock) {

       // GET SCHEDULE FROM ATTRIBUTES
      let schedule = clock.getAttribute('data-holidays');
      schedule = schedule.split(',');
      
      // CREATE DEADLINE (4pm WEEKDAYS)
      const today = new Date();

      let date = new Date(new Date(today).toDateString());
      date.setHours(16);
      date.setMinutes(0);
      date.setSeconds(0);

      const deadline = date;

      // INIT CLOCK
      initializeClock(clock, deadline, schedule, today);
    }
  }
}

/*

  _________________________
< YEEHAW >
  -------------------------
     >>\.
    /_  )`.
   /  _)`^)`.   _.---. _
  (_,' \  `^-)""      `.\
        |              | \
        \              / |
       / \  /.___.'\  (\ (_
      < ,"||     \ |`. \`-'
       \\ ()      )|  )/
       |_>|>     /_] //
         /_]        /_]

*/
